var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"member-info"},[_c('div',{staticClass:"member-avatar"},[_c('img',{attrs:{"src":_vm.data.memberAvatar}})]),_c('div',{staticClass:"member-detail"},[_c('div',{staticClass:"member-name"},[_vm._v(_vm._s(_vm.data.memberName))]),_c('div',{staticClass:"member-department"},[_vm._v(_vm._s(_vm.data.departmentName))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }